import React, { useEffect, useRef, useCallback } from "react"
import Modal from "react-modal"
import clsx from "clsx"
import { getMaterialIconForLevel } from "./LuiBanner"

interface ILuiModal {
  id: string
  shouldCloseOnOverlayClick?: boolean
  onClose?: () => void
  className?: string
}

export const LuiModal: React.FC<ILuiModal> = (props) => {
  const node = useRef(null)

  const handleClickOutside = useCallback(
    (e: any) => {
      // current DOES have a contains!
      if (node?.current && (node.current as any).contains(e.target)) {
        // inside click
        return
      }
      // outside click
      if (props.shouldCloseOnOverlayClick) {
        props.onClose && props.onClose()
      }
    },
    [props]
  )

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [handleClickOutside])

  if (process?.env?.NODE_ENV !== "test") {
    Modal.setAppElement("#root")
  }

  return (
    <Modal
      key={props.id}
      isOpen={true}
      shouldCloseOnOverlayClick={props.shouldCloseOnOverlayClick}
      onRequestClose={props.onClose}
      overlayClassName="modal"
      className="lui-scrim"
    >
      <div ref={node} className={clsx(`lui-modal lui-box-shadow`, props.className)}>
        {props.children}
      </div>
    </Modal>
  )
}

export const LuiAlertModal: React.FC<{ level: "success" | "info" | "warning" | "error" } & ILuiModal> = (props) => {
  let materialIcon = getMaterialIconForLevel(props.level)
  return (
    <LuiModal
      id={props.id}
      shouldCloseOnOverlayClick={props.shouldCloseOnOverlayClick}
      onClose={props.onClose}
      className={clsx(`lui-modal-${props.level}`, props.className)}
    >
      <i className="lui-msg-status-icon material-icons-round">{materialIcon}</i>
      {props.children}
    </LuiModal>
  )
}

export const LuiAlertModalButtons: React.FC = (props) => {
  return <div className="modal-btn-row">{props.children}</div>
}
